import { ResolveFn } from '@angular/router';
import { IUnauthenticatedInvoiceDataDto } from '../interfaces/dtos/client/IUnauthenticatedInvoiceDataDto';
import { inject } from '@angular/core';
import { UnauthenticatedInvoicesService } from '../client/api-services/unauthenticated-invoices.service';

export const getUnauthenticatedInvoiceDataResolver: ResolveFn<IUnauthenticatedInvoiceDataDto | null> = async (route) => {
  const unauthenticatedInvoicesService = inject(UnauthenticatedInvoicesService);
  const invoiceId = route.paramMap.get("invoiceId") ?? "";
  const invoiceUUID = route.paramMap.get("invoiceUUID") ?? "";
  const invoiceIdInt = parseInt(invoiceId);

  if (invoiceUUID.length === 0 || isNaN(invoiceIdInt)){
    return null;
  }

  return new Promise<IUnauthenticatedInvoiceDataDto | null>(resolve => {
    unauthenticatedInvoicesService.GetUnauthenticatedInvoiceData(invoiceIdInt, invoiceUUID).subscribe({
      next: apiResponse => {
        return resolve(apiResponse.Data);
      },
      error: () => {
        return resolve(null);
      }
    })
  });
};
